var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isShowCreateBriefing
        ? _c("ds-modal", {
            attrs: { open: _vm.isModalOpen && !_vm.isShowCreateBriefing },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "modal fade show",
                          staticStyle: { display: "block" },
                          attrs: {
                            id: "go-modal-goover-create-step-1",
                            tabindex: "-1",
                            "aria-hidden": "true",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "modal-dialog go-modal-goover-create channel",
                            },
                            [
                              _c("div", { staticClass: "modal-content" }, [
                                _c("div", { staticClass: "modal-header" }, [
                                  _vm.itemSetting != null
                                    ? _c(
                                        "div",
                                        { staticClass: "go-text-wrap" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "modal-title" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "scrap-create.setting-scrap-title"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p"),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn go-btn-icon close",
                                              attrs: {
                                                type: "button",
                                                "data-dismiss": "modal",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.emitClose.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover",
                                                      value: {
                                                        customClass:
                                                          "go-tooltip",
                                                      },
                                                      expression:
                                                        "{ customClass: 'go-tooltip' }",
                                                      modifiers: {
                                                        hover: true,
                                                      },
                                                    },
                                                  ],
                                                  staticClass:
                                                    "go-tooltip-area",
                                                  attrs: {
                                                    title: _vm.$t(
                                                      "scrap-agent.modal_close"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "go-icon-20 go-icon-close",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.itemSetting == null
                                    ? _c(
                                        "div",
                                        { staticClass: "go-text-wrap" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "modal-title" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "scrap-create.create-scrap-title"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "scrap-create.create-scrap-des"
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn go-btn-icon close",
                                              attrs: {
                                                type: "button",
                                                "data-dismiss": "modal",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.emitClose.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover",
                                                      value: {
                                                        customClass:
                                                          "go-tooltip",
                                                      },
                                                      expression:
                                                        "{ customClass: 'go-tooltip' }",
                                                      modifiers: {
                                                        hover: true,
                                                      },
                                                    },
                                                  ],
                                                  staticClass:
                                                    "go-tooltip-area",
                                                  attrs: {
                                                    title: _vm.$t(
                                                      "scrap-agent.modal_close"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "go-icon-20 go-icon-close",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "modal-body" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "go-form-header" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "go-list-content form",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "go-form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "go-form-label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "scrap-create.create-name"
                                                        )
                                                      )
                                                    ),
                                                    _c("sup", [_vm._v("*")]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "go-input-group",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.formData
                                                              .briefingTitle,
                                                          expression:
                                                            "formData.briefingTitle",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "go-form-control",
                                                      attrs: {
                                                        type: "text",
                                                        autocomplete: "off",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.formData
                                                            .briefingTitle,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.formData,
                                                            "briefingTitle",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.invalidName()
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-form-feedback d-flex justify-content-between",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "go-form-feedback-invalid",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "scrap-agent.home.duplicate-scrap"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "go-form-help",
                                                            class: {
                                                              "text-danger":
                                                                _vm.charNumberBriefingTitle >
                                                                50,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.charNumberBriefingTitle
                                                              ) + " / 50"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.invalidName()
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "go-form-help",
                                                        class: {
                                                          "text-danger":
                                                            _vm.charNumberBriefingTitle >
                                                            50,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.charNumberBriefingTitle
                                                          ) + " / 50"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("hr", { staticClass: "hr-2" }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "go-block-header mb-2" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "scrap-create.scrape-channel"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm.listChannelWithAccount.length != 0
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn go-btn-default",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: _vm.openModalRegister,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "scrap-create.add-channel"
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    [
                                      _vm.loadingRegisterChannel
                                        ? _c(
                                            "div",
                                            { staticClass: "go-loading" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "go-icon-wrap" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "go-icon-54 go-spinner custom-go-spinner",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.loadingRegisterChannel &&
                                      _vm.listChannelWithAccount.length == 0
                                        ? _c(
                                            "div",
                                            { staticClass: "go-no-data" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn go-btn-default",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click:
                                                      _vm.openModalRegister,
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "go-icon-18 go-icon-plus",
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "em",
                                                    { staticClass: "go-text" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "scrap-agent.nodata.register"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "scrap-agent.nodata.title"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("dfn", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "scrap-agent.nodata.des"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("ChannelRegisterCommon", {
                                        attrs: {
                                          listChannel:
                                            _vm.listChannelWithAccount,
                                          itemSetting: _vm.itemSetting,
                                          scrollTop: _vm.isModalOpen,
                                        },
                                        on: {
                                          "update:listChannel": function (
                                            $event
                                          ) {
                                            _vm.listChannelWithAccount = $event
                                          },
                                          "update:list-channel": function (
                                            $event
                                          ) {
                                            _vm.listChannelWithAccount = $event
                                          },
                                          briefingPrivacy: _vm.briefingPrivacy,
                                          deleteScrapAgent:
                                            _vm.deleteScrapAgent,
                                          listChannelRegister:
                                            _vm.handleChangeListStep2,
                                          channelSetting:
                                            _vm.handleChannelSetting,
                                          openLoginAccount:
                                            _vm.handleOpenLoginAccount,
                                          ReAuthor: _vm.handleReAuthorAccount,
                                        },
                                      }),
                                    ],
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "modal-footer flex-row-reverse",
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn go-btn-primary go-btn-lg",
                                        attrs: {
                                          type: "button",
                                          disabled:
                                            _vm.invalidName() ||
                                            _vm.charNumberBriefingTitle > 50 ||
                                            _vm.charNumberBriefingTitle < 1,
                                        },
                                        on: { click: _vm.openModalEnd },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.itemSetting != null
                                                ? _vm.$t("scrap-agent.save")
                                                : _vm.$t("scrap-agent.next")
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              59916580
            ),
          })
        : _vm.isModalOpen
        ? _c(
            "div",
            { staticStyle: { height: "100%" } },
            [
              !_vm.isShowTab
                ? [
                    _c("div", { staticClass: "go-form-title" }, [
                      _c("div", { staticClass: "modal-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("scrap-create.create-scrap-title"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("scrap-create.create-scrap-des"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-form-header" }, [
                      _c("div", { staticClass: "go-list-content form" }, [
                        _c("div", { staticClass: "go-form-group" }, [
                          _c("label", { staticClass: "go-form-label" }, [
                            _vm._v(_vm._s(_vm.$t("scrap-create.create-name"))),
                            _c("sup", [_vm._v("*")]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.formData.briefingTitle,
                                  expression: "formData.briefingTitle",
                                },
                              ],
                              staticClass: "go-form-control",
                              attrs: { type: "text" },
                              domProps: { value: _vm.formData.briefingTitle },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.formData,
                                    "briefingTitle",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _vm.invalidName()
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "go-form-feedback d-flex justify-content-between",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "go-form-feedback-invalid" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "scrap-agent.home.duplicate-scrap"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "small",
                                    {
                                      staticClass: "go-form-help",
                                      class: {
                                        "text-danger":
                                          _vm.charNumberBriefingTitle > 50,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.charNumberBriefingTitle) +
                                          " / 50"
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.invalidName()
                            ? _c(
                                "small",
                                {
                                  staticClass: "go-form-help",
                                  class: {
                                    "text-danger":
                                      _vm.charNumberBriefingTitle > 50,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.charNumberBriefingTitle) +
                                      " / 50"
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("hr", { staticClass: "hr-2" }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "go-block-header",
                        staticStyle: { "margin-bottom": "0.5rem" },
                      },
                      [
                        _c("p", [
                          _vm._v(_vm._s(_vm.$t("scrap-create.scrape-channel"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-default",
                            attrs: { type: "button" },
                            on: { click: _vm.openModalRegister },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("scrap-create.add-channel")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.loadingRegisterChannel
                      ? _c(
                          "div",
                          {
                            staticClass: "go-loading",
                            staticStyle: { height: "calc(100% - 269px)" },
                          },
                          [
                            _c("div", { staticClass: "go-icon-wrap" }, [
                              _c("i", {
                                staticClass:
                                  "go-icon-54 go-spinner custom-go-spinner",
                              }),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.loadingRegisterChannel &&
                    _vm.listChannelWithAccount.length == 0
                      ? _c("div", { staticClass: "go-no-data" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn go-btn-default",
                              attrs: { type: "button" },
                              on: { click: _vm.openModalRegister },
                            },
                            [
                              _c("i", {
                                staticClass: "go-icon-18 go-icon-plus",
                              }),
                              _vm._v(" "),
                              _c("em", { staticClass: "go-text" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("scrap-agent.nodata.register"))
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(_vm._s(_vm.$t("scrap-agent.nodata.title"))),
                          ]),
                          _vm._v(" "),
                          _c("dfn", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("scrap-agent.nodata.des")
                              ),
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("ChannelRegisterCommon", {
                      attrs: { listChannel: _vm.listChannelWithAccount },
                      on: {
                        "update:listChannel": function ($event) {
                          _vm.listChannelWithAccount = $event
                        },
                        "update:list-channel": function ($event) {
                          _vm.listChannelWithAccount = $event
                        },
                        briefingPrivacy: _vm.briefingPrivacy,
                        listChannelRegister: _vm.handleChangeListStep2,
                      },
                    }),
                  ]
                : [
                    _c("div", { staticClass: "go-tab-elements" }, [
                      _c("ul", { staticClass: "nav go-tab-pills" }, [
                        _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "button",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                id: "listChannelButton",
                                type: "button",
                                "data-toggle": "tab",
                                "data-target": "#go-scrap-create",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("cdHome.t189")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "button",
                            {
                              staticClass: "nav-link active",
                              attrs: {
                                type: "button",
                                "data-toggle": "tab",
                                "data-target": "#go-scrap-connect",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("cdHome.t190")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "tab-content",
                        staticStyle: { height: "calc(100% - 50px)" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "tab-pane create fade",
                            attrs: { id: "go-scrap-create" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "tab-wrap" },
                              [
                                _c("div", { staticClass: "go-form-title" }, [
                                  _c("div", { staticClass: "modal-title" }, [
                                    _vm._v(_vm._s(_vm.$t("cdHome.t172"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.$t("cdHome.t153"))),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-form-header" }, [
                                  _c(
                                    "div",
                                    { staticClass: "go-list-content form" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "go-form-group" },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "go-form-label" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("cdHome.t154"))
                                              ),
                                              _c("sup", [_vm._v("*")]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "go-input-group" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.formData
                                                        .briefingTitle,
                                                    expression:
                                                      "formData.briefingTitle",
                                                  },
                                                ],
                                                staticClass: "go-form-control",
                                                attrs: { type: "text" },
                                                domProps: {
                                                  value:
                                                    _vm.formData.briefingTitle,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "briefingTitle",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.invalidName()
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "go-form-feedback d-flex justify-content-between",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "go-form-feedback-invalid",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "scrap-agent.home.duplicate-scrap"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "go-form-help",
                                                      class: {
                                                        "text-danger":
                                                          _vm.charNumberBriefingTitle >
                                                          50,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.charNumberBriefingTitle
                                                        ) + " / 50"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.invalidName()
                                            ? _c(
                                                "small",
                                                {
                                                  staticClass: "go-form-help",
                                                  class: {
                                                    "text-danger":
                                                      _vm.charNumberBriefingTitle >
                                                      50,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.charNumberBriefingTitle
                                                    ) + " / 50"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("hr", { staticClass: "hr-2" }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "go-block-header",
                                    staticStyle: { "margin-bottom": "0.5rem" },
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(_vm._s(_vm.$t("cdHome.t155"))),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn go-btn-default",
                                        attrs: { type: "button" },
                                        on: { click: _vm.openModalRegister },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("cdHome.t156")))]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.loadingRegisterChannel
                                  ? _c("div", { staticClass: "go-loading" }, [
                                      _c(
                                        "div",
                                        { staticClass: "go-icon-wrap" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "go-icon-54 go-spinner custom-go-spinner",
                                          }),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("ChannelRegisterCommon", {
                                  attrs: {
                                    "is-show-tab": _vm.isShowTab,
                                    listChannel: _vm.listChannelWithAccount,
                                  },
                                  on: {
                                    "update:listChannel": function ($event) {
                                      _vm.listChannelWithAccount = $event
                                    },
                                    "update:list-channel": function ($event) {
                                      _vm.listChannelWithAccount = $event
                                    },
                                    briefingPrivacy: _vm.briefingPrivacy,
                                    listChannelRegister:
                                      _vm.handleChangeListStep2,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "tab-pane connect fade show active",
                            attrs: { id: "go-scrap-connect" },
                          },
                          [
                            _c("div", { staticClass: "tab-wrap" }, [
                              _c("div", { staticClass: "go-form-title" }, [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.$t("cdHome.t162"))),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("cdHome.t163"))),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "go-form-header" }, [
                                _c("div", { staticClass: "go-form-group" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-checkbox",
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          type: "checkbox",
                                          id: "customCheck-all-scrap",
                                        },
                                        domProps: {
                                          checked:
                                            _vm.scrapAgentDataList.length > 0 &&
                                            _vm.connectScrapAgentList.length ===
                                              _vm.scrapAgentDataList.length,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.clickScrap(true, null)
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: {
                                            for: "customCheck-all-scrap",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("cdHome.t160")) +
                                              _vm._s(
                                                _vm.connectScrapAgentList
                                                  .length || 0
                                              ) +
                                              "/" +
                                              _vm._s(
                                                _vm.scrapAgentDataList.length ||
                                                  0
                                              ) +
                                              ")\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "go-block-wrap" },
                                [
                                  _c(
                                    "vue-custom-scrollbar",
                                    {
                                      staticClass:
                                        "go-modal-inner overflow-y-scroll custom-height-connect-tab",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "go-block-body",
                                          staticStyle: { height: "100%" },
                                        },
                                        [
                                          _vm.isLoadingGetScrapAgentDataList
                                            ? _c(
                                                "div",
                                                { staticClass: "go-loading" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "go-icon-wrap",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "go-icon-54 go-spinner custom-go-spinner",
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm.scrapAgentDataList
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "go-card-main-card",
                                                },
                                                _vm._l(
                                                  _vm.scrapAgentDataList,
                                                  function (agent, agentIndex) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key:
                                                          "agent-" + agentIndex,
                                                        staticClass:
                                                          "go-list-item",
                                                        attrs: {
                                                          "data-template":
                                                            "card",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "go-card-main",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "go-card-header",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "go-block-top",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "go-info-inline",
                                                                      },
                                                                      [
                                                                        agent.privacy &&
                                                                        agent.privacy ===
                                                                          "PRIVATE"
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "go-info-item go-tooltip-area",
                                                                                attrs:
                                                                                  {
                                                                                    "data-toggle":
                                                                                      "tooltip",
                                                                                    title:
                                                                                      "Private",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "go-icon-18 go-icon-private",
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        agent.subscribeCount
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "go-info-item go-count",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "strong",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        agent.subscribeCount ||
                                                                                          0
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "cdHome.t188"
                                                                                    )
                                                                                  ) +
                                                                                    "\n                              "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "go-info-item go-datetime",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                " +
                                                                                _vm._s(
                                                                                  _vm.formatDateAgo(
                                                                                    _vm.moment(
                                                                                      agent.createdDate
                                                                                    )
                                                                                  ) ||
                                                                                    ""
                                                                                ) +
                                                                                "\n                              "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "go-elements",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "custom-control custom-checkbox",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "input",
                                                                              {
                                                                                staticClass:
                                                                                  "custom-control-input",
                                                                                attrs:
                                                                                  {
                                                                                    type: "checkbox",
                                                                                    id:
                                                                                      "customCheck-agent-" +
                                                                                      agentIndex,
                                                                                  },
                                                                                domProps:
                                                                                  {
                                                                                    checked:
                                                                                      _vm.connectScrapAgentList.includes(
                                                                                        agent.bpId
                                                                                      ),
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.clickScrap(
                                                                                        false,
                                                                                        agent.bpId
                                                                                      )
                                                                                    },
                                                                                },
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "label",
                                                                              {
                                                                                staticClass:
                                                                                  "custom-control-label",
                                                                                attrs:
                                                                                  {
                                                                                    for:
                                                                                      "customCheck-agent-" +
                                                                                      agentIndex,
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "go-card-title",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          agent.briefingPageName ||
                                                                            ""
                                                                        ) +
                                                                        "\n                          "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "go-card-body",
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "go-card-desc-box",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "go-card-desc",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            agent.briefingDescription
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                agent.listDocumentFeatured &&
                                                                agent
                                                                  .listDocumentFeatured
                                                                  .length > 0
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "go-card-sub-list",
                                                                      },
                                                                      _vm._l(
                                                                        _vm.filteredAndSortedItems(
                                                                          agent.listDocumentFeatured
                                                                        ),
                                                                        function (
                                                                          report,
                                                                          reportIndex
                                                                        ) {
                                                                          return _c(
                                                                            "div",
                                                                            {
                                                                              key:
                                                                                "report-" +
                                                                                reportIndex,
                                                                              class:
                                                                                [
                                                                                  "go-list-item",
                                                                                  {
                                                                                    collect:
                                                                                      !report
                                                                                        .parentDocDetail
                                                                                        .image_uri_thumbnail,
                                                                                  },
                                                                                ],
                                                                            },
                                                                            [
                                                                              report
                                                                                .parentDocDetail
                                                                                .image_uri_thumbnail
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "go-card-sub",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "a",
                                                                                        {
                                                                                          staticClass:
                                                                                            "go-card-img",
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "img",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  src: report
                                                                                                    .parentDocDetail
                                                                                                    .image_uri_thumbnail,
                                                                                                },
                                                                                              on: {
                                                                                                error:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.onImageError(
                                                                                                      $event
                                                                                                    )
                                                                                                  },
                                                                                              },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      report.documentType
                                                                                        ? _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "go-card-label",
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "em",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "go-text",
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    _vm._s(
                                                                                                      _vm.$t(
                                                                                                        _vm.makeReportTypeText(
                                                                                                          report.documentType
                                                                                                        )
                                                                                                      )
                                                                                                    )
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "go-card-body",
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "a",
                                                                                            {
                                                                                              staticClass:
                                                                                                "go-card-title",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  report
                                                                                                    .parentDocDetail
                                                                                                    .title
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "go-card-info",
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "span",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "go-datetime",
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    _vm._s(
                                                                                                      _vm.formattedDate(
                                                                                                        report
                                                                                                          .parentDocDetail
                                                                                                          .published_at
                                                                                                      )
                                                                                                    )
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "go-card-sub",
                                                                                    },
                                                                                    [
                                                                                      report
                                                                                        .parentDocDetail
                                                                                        .datasource_channel_type
                                                                                        ? _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "go-card-label",
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "em",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "go-text",
                                                                                                  domProps:
                                                                                                    {
                                                                                                      innerHTML:
                                                                                                        _vm._s(
                                                                                                          _vm.$t(
                                                                                                            "global.channel." +
                                                                                                              report
                                                                                                                .parentDocDetail
                                                                                                                .datasource_channel_type[0]
                                                                                                          )
                                                                                                        ),
                                                                                                    },
                                                                                                }
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "go-card-body",
                                                                                          staticStyle:
                                                                                            {
                                                                                              "min-height":
                                                                                                "93px",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "a",
                                                                                            {
                                                                                              staticClass:
                                                                                                "go-card-title",
                                                                                              domProps:
                                                                                                {
                                                                                                  textContent:
                                                                                                    _vm._s(
                                                                                                      report
                                                                                                        .parentDocDetail
                                                                                                        .source_summary
                                                                                                    ),
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _c(
                                                "div",
                                                { staticClass: "go-empty" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "go-icon-wrap",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "go-icon-72 go-icon-search",
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "go-info-lead",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("cdHome.t191")
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("ModalAccessComponent", {
        attrs: { open: _vm.isShowAccessComponent, itemDelete: _vm.itemDelete },
        on: { "modal:close": _vm.handleAccessDeleteScrap },
      }),
      _vm._v(" "),
      _c("ModalStep3Component", {
        attrs: {
          open: _vm.isShowCreateScrapAgentEnd,
          itemCreateScrapAgent: _vm.itemCreateScrapAgent,
        },
        on: {
          "modal:back": _vm.modalStep3Back,
          "modal:close": _vm.closeModalStep3,
          markDoneCreateScrapAgent: _vm.markDoneCreateScrapAgent,
        },
      }),
      _vm._v(" "),
      _c("ChannelModeModal", {
        attrs: {
          open: _vm.isShowChannelSetting,
          datasource: _vm.state.itemChannelSetting.datasource,
          channelType: _vm.state.itemChannelSetting.channelType,
          channelName: _vm.state.itemChannelSetting.channelName,
          channelImageUri: _vm.state.itemChannelSetting.channelImageUri,
        },
        on: {
          "modal:close": _vm.onUpdateAgentClose,
          "modal:ok": _vm.handleUpdateAgent,
        },
      }),
      _vm._v(" "),
      _c("scrap-agent-modal-channel-register", {
        attrs: {
          open: _vm.isOpenRegister,
          "list-channels": Array.isArray(_vm.listChannel)
            ? _vm.listChannel
            : [],
        },
        on: {
          "show-agent-step2": _vm.handleShowAgent,
          handleConnect: _vm.handleConnectChannelScrapAgent,
          "search-by-category": _vm.handleSearchByCategory,
          handleShowUrlForm: _vm.handleShowUrlForm,
        },
      }),
      _vm._v(" "),
      _c("scrap-agent-modal-step2-login", {
        attrs: {
          open: _vm.isShowStep2Login,
          channelConnect: _vm.channelConnect || {},
          accountNameSettingModalLogin: _vm.accountNameSettingModalLogin,
          accountNameUpdateModalLogin: _vm.accountNameUpdateModalLogin,
        },
        on: {
          "modal:close": _vm.handleCloseLogin,
          "modal:backHome": _vm.handleCloseLoginAccountSetting,
          "modal:openShowAccount":
            _vm.handleShowStep2AccountBeforeConnectNotAccount,
          openShowAccount: _vm.openModalStep2Account,
        },
      }),
      _vm._v(" "),
      _c("scrap-agent-modal-step2-access", {
        attrs: { open: _vm.isShowModalStep2Access, account: this.accountItem },
        on: {
          "modal:close": _vm.handleModalCloseStep2Access,
          "modal:ok": _vm.handleAccess,
        },
      }),
      _vm._v(" "),
      _c("scrap-agent-step2-account", {
        attrs: {
          open: _vm.isShowModalStep2Account,
          channelConnect: _vm.channelConnect || {},
          highLightAccount: _vm.highLightAccount || "",
        },
        on: {
          skipYoutube: _vm.skipBack,
          addItemEmail: _vm.addItemEmail,
          openUpdateLogin: _vm.openUpdateLogin,
          "modal:AddAccount": _vm.handleShowStep2AccountBeforeConnectHasAccount,
          "modal:close": _vm.handleCloseStep2AccountBeforeConnectHasAccount,
          "modal:SubmitAccount": _vm.handleSubmitAccount,
          deleteSuccess: _vm.handleDeleteSuccess,
          ReAuthorizeSuccess: _vm.handleReAuthorizeSuccess,
        },
      }),
      _vm._v(" "),
      _c("scrapAgentModalChannelRegisterUrlForm", {
        attrs: {
          open: _vm.isShowModalRegisterFormUrl,
          sourceCacheList: _vm.sourceCacheList,
          "list-channels": Array.isArray(_vm.listChannel)
            ? _vm.listChannel
            : [],
        },
        on: { addItem: _vm.addItem, "modal:close": _vm.handleCloseUrl },
      }),
      _vm._v(" "),
      _c("AccountConnectLoginCloud", {
        attrs: {
          open: _vm.isShowAccountConnectCloudLogin,
          channelConnect: _vm.channelConnect || {},
        },
        on: {
          userDataCloud: _vm.userDataCloud,
          "modal:AddAccount": _vm.handleShowStep2AccountBeforeConnectHasAccount,
          "modal:close": _vm.handelCloseAccountConnectGoogleLogin,
        },
      }),
      _vm._v(" "),
      _c("scrapAgentAccountOneOneDriver", {
        attrs: {
          open: _vm.isShowRegisterScrapAgentDrive,
          sourceCacheList: _vm.sourceCacheList,
          dataSourceSetting: _vm.dataSourceSetting,
          userEdit: _vm.userEdit || {},
        },
        on: {
          addItemGoogleDrive: _vm.addItemGoogleDrive,
          "modal:close": _vm.handleCloseDrive,
          "modal:ok": _vm.handleSubmitCloud,
        },
      }),
      _vm._v(" "),
      _c("scrap-agent-account-connect-one-driver", {
        attrs: {
          open: _vm.isShowRegisterScrapAgentOneDrive,
          sourceCacheList: _vm.sourceCacheList,
          dataSourceSetting: _vm.dataSourceSetting,
          userEdit: _vm.userEdit || {},
        },
        on: {
          addItemGoogleDrive: _vm.addItemGoogleDrive,
          "modal:close": _vm.handleCloseDrive,
          "modal:ok": _vm.handleSubmitCloud,
        },
      }),
      _vm._v(" "),
      _c("scrap-agent-account-connect-dropbox", {
        attrs: {
          open: _vm.isShowRegisterScrapAgentBoxDrive,
          sourceCacheList: _vm.sourceCacheList,
          dataSourceSetting: _vm.dataSourceSetting,
          userEdit: _vm.userEdit || {},
        },
        on: {
          addItemGoogleDrive: _vm.addItemGoogleDrive,
          "modal:close": _vm.handleCloseDrive,
          "modal:ok": _vm.handleSubmitCloud,
        },
      }),
      _vm._v(" "),
      _c("scrap-agent-account-r-s-s", {
        attrs: {
          open: _vm.isShowRegisterScrapAgentRss,
          sourceCacheList: _vm.sourceCacheList,
        },
        on: { addItemRss: _vm.handeAddRss, "modal:close": _vm.handleCloseRss },
      }),
      _vm._v(" "),
      _c("ScrapAgentMetaSearch", {
        attrs: {
          open: _vm.isShowScrapAgentMetaSearch,
          sourceCacheList: _vm.sourceCacheList,
        },
        on: {
          "modal:close": _vm.handleCloseMetaSearchModal,
          handleAddMetasearchItem: _vm.handleAddMetaSearch,
        },
      }),
      _vm._v(" "),
      _c("ScrapAgentConnectYoutube", {
        attrs: { open: _vm.isShowConnectYoutube },
      }),
      _vm._v(" "),
      _c("ScrapAgentAccountConnectYoutube", {
        attrs: {
          open: _vm.isShowAccountConnectYoutube,
          sourceCacheList: _vm.sourceCacheList,
          dataSourceSetting: _vm.dataSourceSetting,
          channelConnect: _vm.channelConnect || {},
          userEdit: _vm.userEdit || {},
        },
        on: {
          addItemYoutube: _vm.addItemYoutube,
          "modal:close": _vm.handelCloseAccountConnectYoutube,
          "modal:back": _vm.handeBackConnectYoutube,
        },
      }),
      _vm._v(" "),
      _c("ScrapAgentAccountConnectYoutubeLogin", {
        attrs: {
          open: _vm.isShowAccountConnectYoutubeLogin,
          channelConnect: _vm.channelConnect || {},
        },
        on: {
          userData: _vm.userData,
          skipYoutube: _vm.skipBack,
          "modal:AddAccount": _vm.handleShowStep2AccountBeforeConnectHasAccount,
          "modal:close": _vm.handelCloseAccountConnectGoogleLogin,
        },
      }),
      _vm._v(" "),
      _c("ScrapAgentConnectReddit", {
        attrs: { open: _vm.isShowConnectReddit },
      }),
      _vm._v(" "),
      _c("ScrapAgentRedditLogin", { attrs: { open: _vm.isShowRedditLogin } }),
      _vm._v(" "),
      _c("ScrapAgentRedditAccount", {
        attrs: { open: _vm.isShowRedditAccount },
      }),
      _vm._v(" "),
      _c("ScrapAgentConnectTweeter", {
        attrs: { open: _vm.isShowConnectTweeter },
      }),
      _vm._v(" "),
      _c("AccountTwitterLogin", {
        attrs: {
          open: _vm.isShowTwitterLogin,
          channelConnect: _vm.channelConnect || {},
        },
        on: { "modal:close": _vm.handelCloseTwitter },
      }),
      _vm._v(" "),
      _c("AccountTwitterMode", {
        attrs: {
          open: _vm.isShowTwitterMode,
          userEdit: _vm.userEdit || {},
          sourceCacheList: _vm.sourceCacheList,
          dataSourceSetting: _vm.dataSourceSetting,
          channelConnect: _vm.channelConnect || {},
        },
        on: {
          addItemTwitter: _vm.addItemTwitter,
          "modal:close": _vm.handelCloseTwitter,
        },
      }),
      _vm._v(" "),
      _c("ScrapAgentFacebookLogin", {
        attrs: { open: _vm.isShowFacebookLogin },
        on: { "modal:close": _vm.handleCloseFaceBookLogin },
      }),
      _vm._v(" "),
      _c("ScrapAgentFacebookAccount", {
        attrs: {
          open: _vm.isShowFacebookAccount,
          channelConnect: _vm.channelConnect || {},
          userEdit: _vm.userEdit || {},
        },
        on: {
          addItemFacebook: _vm.addItemFacebook,
          "modal:close": _vm.handleCloseFacebookAccount,
          "modal:back": _vm.handleBackFacebookAccount,
        },
      }),
      _vm._v(" "),
      _c("AccountNaverBlogMode", {
        attrs: {
          open: _vm.isShowAccountNaverBlogMode,
          channelConnect: _vm.channelConnect || {},
          sourceCacheList: _vm.sourceCacheList,
          dataSourceSetting: _vm.dataSourceSetting,
          userEdit: _vm.userEdit || {},
        },
        on: {
          addItemNaverBlog: _vm.addItemNaverBlog,
          "modal:close": _vm.handelCloseBlog,
        },
      }),
      _vm._v(" "),
      _c("AccountBrunchMode", {
        attrs: {
          open: _vm.isShowAccountBrunchMode,
          channelConnect: _vm.channelConnect || {},
          sourceCacheList: _vm.sourceCacheList,
          userEdit: _vm.userEdit || {},
        },
        on: {
          addItemBrunch: _vm.addItemBlog,
          "modal:close": _vm.handelCloseBrunch,
        },
      }),
      _vm._v(" "),
      _c("AccountMediumMode", {
        attrs: {
          open: _vm.isShowAccountMediumMode,
          sourceCacheList: _vm.sourceCacheList,
          channelConnect: _vm.channelConnect || {},
        },
        on: {
          addItemMedium: _vm.addItemBlog,
          "modal:close": _vm.handelCloseMedium,
        },
      }),
      _vm._v(" "),
      _c("AccountWordpressLogin", {
        attrs: {
          open: _vm.isShowAccountWordpressLogin,
          channelConnect: _vm.channelConnect || {},
        },
        on: { "modal:close": _vm.handelCloseWordpress },
      }),
      _vm._v(" "),
      _c("AccountWordpressMode", {
        attrs: {
          open: _vm.isShowAccountWordpressMode,
          channelConnect: _vm.channelConnect || {},
          sourceCacheList: _vm.sourceCacheList,
          dataSourceSetting: _vm.dataSourceSetting,
          userEdit: _vm.userEdit || {},
        },
        on: {
          addItemWordpress: _vm.addItemWordpress,
          "modal:close": _vm.handelCloseBlog,
        },
      }),
      _vm._v(" "),
      _c("ScrapAgentConnectEmail"),
      _vm._v(" "),
      _c("ScrapAgentEmailLogin", {
        attrs: {
          open: _vm.isShowEmailLogin,
          channelConnect: _vm.channelConnect || {},
          typeEmail: _vm.typeEmail,
        },
        on: { "modal:close": _vm.handelCloseEmailLogin },
      }),
      _vm._v(" "),
      _c("ScrapAgentEmailAccount", {
        attrs: { open: _vm.isShowEmailAccount },
        on: { "modal:close": _vm.handelCloseEmailLogin },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }